export const CAMPAIGNS_TOOLTIP_CLASS = 'campaignsTooltip';
